module.exports = __webpack_public_path__ + "static/img/3.10339878.png";